"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcArrowButton = void 0;
var react_1 = __importDefault(require("react"));
var AcButton_1 = require("./AcButton");
var FaIcon_1 = require("../util/FaIcon");
var AcArrowButton = function (_a) {
    var direction = _a.direction, _b = _a.variant, variant = _b === void 0 ? 'main' : _b, className = _a.className, children = _a.children, label = _a.label, // Disabled
    rest = __rest(_a, ["direction", "variant", "className", "children", "label"]);
    var btnVariant = variant;
    var renderDirectionalIcon = function () {
        switch (direction) {
            case 'left':
                return react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-chevron-left", size: "big" });
            case 'right':
                return react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-chevron-right", size: "big" });
            default:
                return react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-question-circle", size: "big" });
        }
    };
    return (react_1.default.createElement(AcButton_1.AcButton, __assign({}, rest, { variant: btnVariant, className: className }), renderDirectionalIcon()));
};
exports.AcArrowButton = AcArrowButton;
exports.AcArrowButton.displayName = 'AcArrowButton';
//# sourceMappingURL=AcArrowButton.js.map